import styles from './styles.module.css';
import cx from 'classnames';

const Section = ({className, children, bgColor, bleed}) => (
  <div style={{ backgroundColor: bgColor}} className={cx(styles.container, className, {[styles.bleed]: bleed})}>
    {children}
  </div>
)

export default Section